export type CourseTitleFields = {
  title?: string | null;
  source_system_class_id?: string | null;
};

/**
 * Course details hero title: "CODE: Title" when a class code exists, otherwise the title alone.
 */
export function getCourseTitleDisplay(course: CourseTitleFields | null | undefined): string {
  const title = course?.title ?? "";
  const code = typeof course?.source_system_class_id === "string" ? course.source_system_class_id.trim() : "";

  if (!code) {
    return title;
  }

  return `${code}: ${title}`;
}
